// extracted by mini-css-extract-plugin
export var root = "KzWN";
export var rootContainer = "KMUP";
export var rootCta = "_6e7a";
export var rootCtaLink = "zPr3";
export var rootGrid = "cP8z";
export var rootHeading = "_73xb";
export var rootItem = "_60-l";
export var rootItemIcon = "yjyM";
export var rootItemText = "Ijtk";
export var rootItemTitle = "_3Rd9";